export default __webpack_public_path__ + "static/media/product.bb451e1c.png";